import styled from 'styled-components';
import { Spinner as ChakraSpinner } from '@chakra-ui/react';

interface IStyledSpinnerProps {
  readonly size: number;
}
export const StyledSpinner = styled(ChakraSpinner)<IStyledSpinnerProps>`
  border-color: #fff;
  border-left-color: transparent !important;
  border-bottom-color: transparent !important;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
`;
